import { useTranslation } from "react-i18next";

export default function ProblemSection() {
  const { t } = useTranslation();

  const problems = [
    {
      icon: "ri-map-pin-2-line",
      title: t("problem.problem1_title"),
      desc: t("problem.problem1_desc"),
      img: "https://readdy.ai/api/search-image?query=Narrow%20unpaved%20alleyway%20in%20Douala%20Cameroon%20neighborhood%20residential%20area%20no%20street%20signs%20informal%20housing%20warm%20afternoon%20light%20realistic%20documentary%20style%20authentic%20African%20urban%20scene%20natural%20colors%20editorial%20photography&width=600&height=400&seq=problem-address-v2&orientation=landscape"
    },
    {
      icon: "ri-restaurant-line",
      title: t("problem.problem2_title"),
      desc: t("problem.problem2_desc"),
      img: "https://readdy.ai/api/search-image?query=Small%20local%20chop%20bar%20in%20Yaounde%20Cameroon%20modest%20street%20side%20food%20stall%20with%20simple%20tables%20traditional%20Cameroonian%20dishes%20served%20on%20plates%20warm%20natural%20lighting%20authentic%20humble%20setting%20documentary%20photography%20realistic%20scene&width=600&height=400&seq=problem-chopbar-v2&orientation=landscape"
    },
    {
      icon: "ri-time-line",
      title: t("problem.problem3_title"),
      desc: t("problem.problem3_desc"),
      img: "https://readdy.ai/api/search-image?query=Takeaway%20food%20packaging%20scattered%20on%20table%20cold%20soggy%20meal%20disappointing%20delivery%20experience%20warm%20indoor%20lighting%20realistic%20product%20photography%20simple%20composition%20neutral%20background&width=600&height=400&seq=problem-delivery-v2&orientation=landscape"
    },
    {
      icon: "ri-eye-off-line",
      title: t("problem.problem4_title"),
      desc: t("problem.problem4_desc"),
      img: "https://readdy.ai/api/search-image?query=Hidden%20alleyway%20street%20food%20vendor%20woman%20cooking%20traditional%20Cameroonian%20dish%20over%20charcoal%20fire%20in%20Douala%20backstreet%20obscured%20from%20main%20road%20vibrant%20colorful%20market%20behind%20her%20authentic%20candid%20scene%20golden%20hour%20lighting%20editorial%20photography&width=600&height=400&seq=problem-hidden-v2&orientation=landscape"
    },
  ];

  return (
    <section className="relative w-full py-20 md:py-28 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10 max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14 md:mb-20">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold uppercase tracking-wider mb-5">
            {t("problem.title")}
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-5">
            {t("problem.subtitle")}
          </h2>
          <div className="w-20 h-1 bg-accent-500 rounded-full mx-auto"></div>
        </div>

        {/* Problem Cards - 2x2 Grid with images */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {problems.map((problem, index) => (
            <div
              key={index}
              className="group bg-background-100 rounded-2xl overflow-hidden border border-background-200 hover:border-accent-200 transition-all duration-500 hover:shadow-lg"
            >
              <div className="grid grid-cols-1 sm:grid-cols-2">
                {/* Image */}
                <div className="relative h-48 sm:h-full overflow-hidden">
                  <img
                    src={problem.img}
                    alt={problem.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-background-100 sm:bg-gradient-to-t sm:from-transparent"></div>
                </div>
                {/* Text */}
                <div className="p-6 md:p-7 flex flex-col justify-center">
                  <div className="w-11 h-11 rounded-xl bg-accent-100 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className={`${problem.icon} text-accent-600 text-lg`}></i>
                    </div>
                  </div>
                  <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">
                    {problem.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {problem.desc}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}